var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandDelete24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 18,
    viewBox: "0 0 15.998 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_brand_delete24x24",
    transform: "translate(-4.002 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(4 3)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46218",
    "data-name": "Path 46218",
    d: "M126.706,1.165h3.437v.543h1.241V1.089A1.127,1.127,0,0,0,130.225,0h-3.6a1.127,1.127,0,0,0-1.16,1.089v.619h1.241Zm0,0",
    transform: "translate(-120.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46219",
    "data-name": "Path 46219",
    d: "M52.691,167.75H41.037a.527.527,0,0,0-.545.554l.974,11.306a1.264,1.264,0,0,0,1.289,1.117h8.216a1.264,1.264,0,0,0,1.289-1.117l.974-11.306a.527.527,0,0,0-.545-.554Zm-8.832,11.772H43.82a.6.6,0,0,1-.619-.547l-.611-9.282a.6.6,0,0,1,.581-.617.609.609,0,0,1,.658.546l.61,9.282a.6.6,0,0,1-.58.618Zm3.633-.581a.622.622,0,0,1-1.241,0v-9.282a.622.622,0,0,1,1.241,0Zm3.646-9.248-.583,9.282a.6.6,0,0,1-.619.548H49.9a.6.6,0,0,1-.583-.616l.583-9.282a.607.607,0,0,1,.656-.547.6.6,0,0,1,.581.615Zm0,0",
    transform: "translate(-38.864 -162.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46220",
    "data-name": "Path 46220",
    d: "M15.974,77.865l-.408-1.147a.787.787,0,0,0-.749-.506H1.183a.787.787,0,0,0-.749.506L.027,77.865a.466.466,0,0,0,.215.559.532.532,0,0,0,.271.073H15.488a.53.53,0,0,0,.271-.073.466.466,0,0,0,.215-.559Zm0,0",
    transform: "translate(0 -74.64)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandDelete24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand_delete24x24.2a5ae596188b7f537622422773b875d4.svg";